export default "__VITE_ASSET__1a7f5d7f__"